import { render, staticRenderFns } from "./buyerInfo.vue?vue&type=template&id=428f20b4&scoped=true&"
import script from "./buyerInfo.vue?vue&type=script&lang=js&"
export * from "./buyerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f20b4",
  null
  
)

export default component.exports